export enum SpeakerType {
	Megaphone,
	ScreenShare,
}

export type Speaker = {
	userId: string
	speakerType: SpeakerType
}

export enum SpeakerUpdateType {
	Init,
	Change,
	Delete,
}

export type SpeakerUpdateInit = {
	type: SpeakerUpdateType.Init
	speaker: Record<string, Speaker>
}

export type SpeakerUpdateChange = {
	type: SpeakerUpdateType.Change
	speaker: Record<string, Speaker>
}

export type SpeakerUpdatDelete = {
	type: SpeakerUpdateType.Delete
	id: string
}
